import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import LoginAccountPassword from "../LoginAccountPassword";
import DingdingCodeLogin from "../DingdingCodeLogin";
import LoginCode from "../LoginCode";
import EntryInputCode from "../EntryInputCode";
import LoginCodeSetName from "../LoginCodeSetName";
import LoginCodeSetPassword from "../LoginCodeSetPassword";
import LoginWorkWechat from "../LoginWorkWechat";
import LoginWechat from "../LoginWechat";
import ForgetPassword from "../ForgetPassword";
import LoginUserActivation from "../LoginUserActivation";
import LoginWXReg from "../LoginWXReg";
import DingdingBind from "../DingdingBind";
import LoginFeishu from "../LoginFeishu";
import LoginSSO from "../LoginSSO";
import LoginQYZJwechat from "../LoginQYZJwechat";
import tipAlert from "../BsyAlertTip/Staticize";
import DingdingTeamLogin from "../DingdingTeamLogin";
import mobileEmptyImg from "../../images/img_dengluyichang.png"
import './index.css'

export default class LoginRightCont extends Component {
    constructor(props) {
        super(props);
        let defaultLogin = window.data_config.defaultLogin;
        if(this.GetQueryString('type') === 'register'){
            defaultLogin = "codeLogin"
        }
        if (window.location.href.indexOf('/user/login') !== -1) {
            this.state = {
                pageSwitch: {
                    EntryInputCodeShow: false,
                    ISMobile: false,
                    LoginAccountPasswordShow: defaultLogin === "commonLogin",
                    LoginDingdingCodeShow: defaultLogin === "dingdingLogin",
                    LoginWorkWechatShow: defaultLogin === "qywxLogin",
                    LoginWechatShow: defaultLogin === "weixinLogin",
                    LoginFeishuShow: defaultLogin === "feishuLogin",
                    LoginQyWechatShow: defaultLogin === "qywxZJLogin",
                    LoginZJQyWechatShow: defaultLogin === "qywxZJMobileLogin",
                    LoginCodeSetNameShow: false,
                    LoginCodeSetPasswordShow: false,
                    LoginSSOShow: false,
                    LoginCodeShow: defaultLogin === "codeLogin"
                },
                ...props.customLoginConfig
            }
        } else if (window.location.href.indexOf('/corp/url/') !== -1 || window.location.href.indexOf('/corp/login_setting') !== -1) {
            this.state = {
                pageSwitch: {
                    LoginWechatShow: defaultLogin === "weixinLogin",
                    EntryInputCodeShow: false,
                    LoginAccountPasswordShow: true,
                    LoginCodeSetNameShow: false,
                    LoginCodeSetPasswordShow: false,
                    LoginSSOShow: false,
                    LoginCodeShow: false
                },
                ...props.customLoginConfig
            }
        } else {
            this.state = {
                pageSwitch: {},
                ...props.customLoginConfig
            }
        }

        let CookieStatePageSwitch = React.cookie.load('CookieStatePageSwitch')


        if (!window.data_config.mobileCodeLogin && !window.data_config.emailCodeLogin) {
            CookieStatePageSwitch && CookieStatePageSwitch.pageSwitch && (CookieStatePageSwitch.pageSwitch.LoginCodeShow = false);
        }
        if (CookieStatePageSwitch) {
            let allClose = false;
            if (CookieStatePageSwitch.pageSwitch) {
                for (let key in CookieStatePageSwitch.pageSwitch) {
                    if (CookieStatePageSwitch.pageSwitch[key]) {
                        allClose = true;
                    }
                }
                if (!allClose) {
                    CookieStatePageSwitch = this.state;
                }
            }
        }
        if (window.screen.width <= 1200) {
            if (CookieStatePageSwitch) {
                if (CookieStatePageSwitch.pageSwitch) {
                    CookieStatePageSwitch.pageSwitch.LoginDingdingCodeShow = false;
                    CookieStatePageSwitch.pageSwitch.LoginWorkWechatShow = false;
                    CookieStatePageSwitch.pageSwitch.LoginWechatShow = false;
                    CookieStatePageSwitch.pageSwitch.LoginFeishuShow = false;
                    CookieStatePageSwitch.pageSwitch.LoginQyWechatShow = false;
                    CookieStatePageSwitch.pageSwitch.LoginZJQyWechatShow = false;
                    CookieStatePageSwitch.pageSwitch.LoginSSO = false;
                    if (!window.data_config.mobileCodeLogin && !window.data_config.emailCodeLogin) {
                        CookieStatePageSwitch.pageSwitch.LoginCodeShow = false;
                    }
                    if (!CookieStatePageSwitch.pageSwitch.LoginAccountPasswordShow && !window.data_config.mobileCodeLogin && !window.data_config.emailCodeLogin) {
                        CookieStatePageSwitch.pageSwitch.ISMobileEmpty = true;
                    }
                }
                if (!CookieStatePageSwitch.pageSwitch.LoginAccountPasswordShow && !CookieStatePageSwitch.pageSwitch.LoginCodeShow) {
                    CookieStatePageSwitch.pageSwitch.LoginAccountPasswordShow = true;
                }
            } else {
                this.state.pageSwitch.LoginDingdingCodeShow = false;
                this.state.pageSwitch.LoginWorkWechatShow = false;
                this.state.pageSwitch.LoginFeishuShow = false;
                this.state.pageSwitch.LoginQyWechatShow = false;
                this.state.pageSwitch.LoginZJQyWechatShow = false;
                this.state.pageSwitch.LoginWechatShow = false;
                this.state.pageSwitch.LoginSSOShow = false;
                
                if (!window.data_config.mobileCodeLogin && !window.data_config.emailCodeLogin) {
                    this.state.pageSwitch.LoginCodeShow = false;
                }
                if (window.data_config.defaultLogin !== "commonLogin" && window.data_config.defaultLogin !== "codeLogin") {
                    this.state.pageSwitch.LoginAccountPasswordShow = true;
                }
            }
        }

        if(window.data_config.customLogin && (!props.customLoginConfig.hasSSOLogin || !props.customLoginConfig.hasAccountLogin)){
            this.state.pageSwitch.LoginAccountPasswordShow = false;
            this.state.pageSwitch.LoginCodeShow = false;
            if(props.customLoginConfig.hasSSOLogin){
                this.state.pageSwitch.LoginSSOShow = true;
            }else if(props.customLoginConfig.hasAccountLogin){
                this.state.pageSwitch.LoginAccountPasswordShow = true;
            }
        }


        if(this.GetQueryString('type') !== 'register'){
            CookieStatePageSwitch && (this.state.pageSwitch = { ...CookieStatePageSwitch.pageSwitch })
        }
    }

    GetQueryString(name) { 
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
        var r = window.location.search.substr(1).match(reg); 
        if (r != null) {  
          return unescape(r[2]); 
        } 
        return null; 
      }

    componentDidMount() {
        this.props.headerShow && this.props.headerShow(this);
    }

    changeContModePage = (value) => {
        return (event) => {
            const { pageSwitch } = this.state;
            for (let key in pageSwitch) {
                pageSwitch[key] = false;
                if (key === value) pageSwitch[key] = true;
            }
            React.cookie.save('CookieStatePageSwitch', { pageSwitch: pageSwitch })
            this.setState({ pageSwitch: pageSwitch })
        }
    }

    changeContCodePage = (value) => {
        const { pageSwitch } = this.state;
        for (let key in pageSwitch) {
            pageSwitch[key] = false;
            if (key === value) pageSwitch[key] = true;
        }
        this.setState({ pageSwitch: pageSwitch })
    }

    LoginCodeClick = (values, state, cd) => {
        const { value, accountType, countryCode, type } = state
        this.timer1 = setTimeout(() => {
            const data = type ? {
                "mode": type,
                "data": {
                    "code": values
                }
            } : accountType === "email" ? {
                "mode": "email",
                "data": {
                    "email": value,
                    "code": values
                }
            } : {
                "mode": "mobile",
                "data": {
                    "mobile": value,
                    "country_code": countryCode,  //地区编码
                    "code": values
                }
            }
            React.axios('/user/signin', data).then(res => {
                if (res.data.code === 200) {
                    tipAlert({
                        type: "success",
                        msg: res.data.msg
                    })
                    window.location.href = res.data.redirectTo
                } else if (res.data.code === 201) {
                    tipAlert({
                        type: "success",
                        msg: res.data.msg
                    })
                    this.changeContCodePage("LoginCodeSetPasswordShow")
                } else if (res.data.code === 202) {
                    tipAlert({
                        type: "success",
                        msg: res.data.msg
                    })
                    this.changeContCodePage("LoginCodeSetNameShow")
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
            }).catch(res => {
                const res1 =  res.response ? res.response.data : res.data;
                this.imgCode && this.imgCode.changeCode()
                if (res1.toString().indexOf('"Message":"OK"') === -1) {
                    if (res1.toString().indexOf('code')) {
                        // tipAlert({
                        //     type: "error",
                        //     msg: res1.msg
                        // })
                        cd && cd(!0, res1.msg);
                    }
                    else {
                        // tipAlert({
                        //     type: "error",
                        //     msg: React.language("System.error")
                        // })
                        cd && cd(!0, React.language("System.error"));
                    }
                } else {
                    if (res1.code === 200) {
                        tipAlert({
                            type: "success",
                            msg: res1.data.msg
                        })
                        window.location.href = res1.redirectTo
                    } else if (res1.code === 201) {
                        tipAlert({
                            type: "success",
                            msg: res1.msg
                        })
                        this.changeContCodePage("LoginCodeSetPasswordShow")
                    } else if (res1.code === 202) {
                        tipAlert({
                            type: "success",
                            msg: res1.msg
                        })
                        this.changeContCodePage("LoginCodeSetNameShow")
                    }
                }
            })
        }, 300)
    }

    changeContPage = (value) => {
        return (event) => {
            const { pageSwitch } = this.state;
            for (let key in pageSwitch) {
                pageSwitch[key] = false;
                if (key === value) pageSwitch[key] = true;
            }
            this.setState({ pageSwitch: pageSwitch })
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer1)
    }

    render() {
        const { rightTitle, isMirror, customLoginConfig } = this.props
        const SSOMode = {
            dingdingShow: false,
            workWechatShow: false,
            SSOShow: window.data_config.hassso,
            wechatShow: false
        }
        const { pageSwitch, hasAccountLogin, hasSSOLogin, register } = this.state
        let { LoginSSOShow, EntryInputCodeShow, LoginZJQyWechatShow, LoginCodeSetNameShow, LoginCodeSetPasswordShow, LoginCodeShow, LoginAccountPasswordShow, LoginDingdingCodeShow, LoginWorkWechatShow, LoginWechatShow, LoginFeishuShow, LoginQyWechatShow } = pageSwitch
        
        return (
            <div className={"rightCont" + (isMirror ? " isMirror" : "")}>
                <Switch>
                    <Route path={window.rootDirectroy + "/user/login"}>
                        {(LoginAccountPasswordShow) && <LoginAccountPassword customLoginConfig={customLoginConfig} isMirror={isMirror} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {(LoginDingdingCodeShow) && <DingdingCodeLogin customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} />}
                        {(LoginWorkWechatShow) && <LoginWorkWechat customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} />}
                        {(LoginFeishuShow) && <LoginFeishu customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} />}
                        {/* {(LoginQyWechatShow) && <LoginQyWechat changeContModePage={this.changeContModePage} />} */}
                        {(LoginZJQyWechatShow || LoginQyWechatShow) && <LoginQYZJwechat customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} />}
                        {(LoginWechatShow) && <LoginWechat customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} />}
                        {(LoginCodeShow) && <LoginCode customLoginConfig={customLoginConfig} isMirror={isMirror} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {EntryInputCodeShow && <EntryInputCode  customLoginConfig={customLoginConfig}LoginCode={this.LoginCodeClick} changeContCodePage={this.changeContCodePage} changeContPage={this.changeContPage} />}
                        {LoginCodeSetNameShow && <LoginCodeSetName customLoginConfig={customLoginConfig}changeContCodePage={this.changeContCodePage} />}
                        {LoginCodeSetPasswordShow && <LoginCodeSetPassword customLoginConfig={customLoginConfig} changeContPage={this.changeContPage} />}
                        {(window.screen.width <= 1200 && (!window.data_config.commonLogin && (!window.data_config.mobileCodeLogin && !window.data_config.emailCodeLogin))) && <div className="mobileEmpty">
                            <img src={mobileEmptyImg} alt="" />
                            <p>
                                {React.language('mobile.login.empty.tip')}
                            </p>
                        </div>}
                    </Route>
                    <Route path={window.rootDirectroy + "/user/getpwd"} component={ForgetPassword} />
                    <Route path={window.rootDirectroy + "/user/userActivation"} component={LoginUserActivation} />
                    <Route path={window.rootDirectroy + "/user/wxreg"} component={LoginWXReg} />
                    <Route path={window.rootDirectroy + "/dingding/dd_or_code_corp_list"} component={DingdingBind} />
                    <Route path={window.rootDirectroy + "/dingding/dd_mobile_sm"} component={DingdingTeamLogin} />
                    <Route path={window.rootDirectroy + "/dingding/team"} component={DingdingTeamLogin} />
                    <Route path={window.rootDirectroy + "/corp/url/"}>
                        {LoginAccountPasswordShow && <LoginAccountPassword customLoginConfig={customLoginConfig} isMirror={isMirror} isCorp={true} modeBtnShow={SSOMode} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {LoginCodeShow && <LoginCode customLoginConfig={customLoginConfig} isMirror={isMirror} modeBtnShow={SSOMode} isCorp={true} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {LoginSSOShow && <LoginSSO customLoginConfig={customLoginConfig} isMirror={isMirror} modeBtnShow={SSOMode} isCorp={true} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {(LoginWechatShow) && <LoginWechat isCorp={true} customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} changeContCodePage={this.changeContCodePage}  />}
                        {EntryInputCodeShow && <EntryInputCode LoginCode={this.LoginCodeClick} changeContCodePage={this.changeContCodePage} changeContPage={this.changeContPage} />}
                        {LoginCodeSetNameShow && <LoginCodeSetName changeContCodePage={this.changeContCodePage} />}
                        {LoginCodeSetPasswordShow && <LoginCodeSetPassword changeContPage={this.changeContPage} />}
                    </Route>
                    <Route path={window.rootDirectroy + "/corp/login_setting"}>
                        {LoginAccountPasswordShow && <LoginAccountPassword customLoginConfig={customLoginConfig} isMirror={isMirror} isCorp={true} modeBtnShow={SSOMode} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {LoginCodeShow && <LoginCode customLoginConfig={customLoginConfig} isMirror={isMirror} modeBtnShow={SSOMode} isCorp={true} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {LoginSSOShow && <LoginSSO customLoginConfig={customLoginConfig} isMirror={isMirror} modeBtnShow={SSOMode} isCorp={true} changeContCodePage={this.changeContCodePage} changeContModePage={this.changeContModePage} rightTitle={rightTitle} />}
                        {(LoginWechatShow) && <LoginWechat isCorp={true} customLoginConfig={customLoginConfig} changeContModePage={this.changeContModePage} changeContCodePage={this.changeContCodePage}  />}
                        {EntryInputCodeShow && <EntryInputCode LoginCode={this.LoginCodeClick} changeContCodePage={this.changeContCodePage} changeContPage={this.changeContPage} />}
                        {LoginCodeSetNameShow && <LoginCodeSetName changeContCodePage={this.changeContCodePage} />}
                        {LoginCodeSetPasswordShow && <LoginCodeSetPassword changeContPage={this.changeContPage} />}
                    </Route>
                    <Redirect to={window.rootDirectroy + "/user/login"} />
                </Switch>
            </div>
        );
    }
}